import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import {
  filterEmergencyCalls,
  filterAniAliCalls,
} from '../../utils/filterEmergencyCalls';
import { setCallFilters } from '../emergencyCalls/emergencyCallsSlice';

export const callQueueSelector = createSelector(
  [callQueue => callQueue, (state, hasAniAliAccess) => hasAniAliAccess],
  (callQueue, hasAniAliAccess) => {
    return hasAniAliAccess
      ? filterEmergencyCalls(callQueue)
      : filterAniAliCalls(filterEmergencyCalls(callQueue));
  },
);

// TODO: useSelectedCall must take into consideration outbound SMS. See callQueueSelectorNext

export const useSelectedCall = () => {
  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );

  const call = useSelector(
    state => state.emergencyCalls.callQueue[selectedCallerID],
  );

  return call;
};

export const useCallQueueFilters = () => {
  const dispatch = useDispatch();
  const callFilters = useSelector(
    state => state.emergencyCalls?.callFilters || {},
  );

  const hasActiveCallFilters = useMemo(
    () => Object.values(callFilters).some(filter => filter),
    [callFilters],
  );

  const toggleSetCallFilter = useCallback(
    (filterType, setValue = null) => {
      dispatch(
        setCallFilters({
          ...callFilters,
          [filterType]:
            typeof setValue === 'boolean' ? setValue : !callFilters[filterType],
        }),
      );
    },
    [dispatch, callFilters],
  );

  return { callFilters, toggleSetCallFilter, hasActiveCallFilters };
};
